/*
 * @Author: your name
 * @Date: 2022-01-20 10:15:14
 * @LastEditTime: 2022-02-21 11:23:35
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /fore-movie-h5/src/pages/movieSeat/components/PayPassword/password/index.tsx
 */
import React, {Fragment, memo} from 'react';
import Ejected from '../ejected';
import Keyboard from '../keyboard';
import BackImg from '../imgs/back.png';
// import './index.less';
import styles from './index.less';
const prefix = 'qyf';

const Password = (props) => {
  const { visit, title, goBack, onChange, children } = props;

  const EjectHeader = ({title = '', callback}) => (
    <div className={`${styles.qyfPasswordHeader}`}>
      <img
        className={`${styles.qyfPasswordGoback}`}
        onTouchStart={() => {
            callback && callback();
          }}
        src={BackImg}
        alt="返回"
      />
      <div>{title}</div>
    </div>
    );

  return (
    <>
      {visit && (
        <Ejected isShow={visit} className={styles.qyfEjectAnimate}>
          <Fragment>
            {/* Eject Header */}
            <EjectHeader title={title} callback={goBack} />
            {/* 展示内容 */}
            <div>{children}</div>
            {/* 键盘 */}
            <Keyboard callback={(item) => {
              onChange && onChange(item);
            }}
            />
          </Fragment>
        </Ejected>
      )}
    </>
  );
};

export default Password;
